import { render } from "./Dialog2.vue?vue&type=template&id=17e6c45a&scoped=true"
import script from "./Dialog2.vue?vue&type=script&lang=js"
export * from "./Dialog2.vue?vue&type=script&lang=js"

import "./Dialog2.vue?vue&type=style&index=0&id=17e6c45a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e6c45a"]])

export default __exports__